var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('school-recipient',{staticClass:"mt-2",attrs:{"model":_vm.schema.recipient}}),_c('w-input',{staticClass:"mt-2",attrs:{"model":_vm.schema.schoolYear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }